import { getEntitySelector } from "@client/lib/layout";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, type WithPrefix, getBackgroundSettingSelector, getSettingValueSelector } from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";
import React from "react";
import { Background, type BackgroundProps } from "./component";

type BackgroundBaseProps = Partial<WithPrefix> &
  Partial<EntityRef> & {
    containerSelector: string;
    radius?: string;
  };
const makeBackground = (target: string) => {
  const makeMapStateToProps = () => {
    const settingSelector = getBackgroundSettingSelector(target);
    const radiusSelector = getSettingValueSelector(target, "radius", "border");

    return (state: AppState, props: BackgroundBaseProps): BackgroundProps => ({
      ...props,
      radius: props.radius ?? radiusSelector(state, props as any),
      value: settingSelector(state, props)
    });
  };

  return connectCustom(makeMapStateToProps)(Background);
};

export const BackgroundContainer = makeBackground(TargetSelector.Layout);

export type BackgroundEntityProps = EntityRef &
  Partial<WithPrefix> & {
    containerSelector?: string;
    subSelector?: string;
  };
const BackgroundEntityInner = makeBackground(TargetSelector.Entity);
export const BackgroundEntityContainer = ({ containerSelector, ...props }: BackgroundEntityProps) => (
  <BackgroundEntityInner
    {...props}
    containerSelector={containerSelector ?? getEntitySelector(props.id) + (props.subSelector ?? "")}
  />
);
